import { Box } from "@mui/material";
import dayjs from "dayjs";
import OutlineCard from "../../../../../../components/OutlineCard";
import ProfileViewer from "../../../../../../components/ProfileViewer";
import Text from "../../../../../../components/Text";
import { DATE_FORMAT } from "../../../../../../utils/date-time-utility";

interface PatientInsuranceDetailsProps {
  values: any;
}

const PRIMARY_CARD_HOLDER_MAPPER: Record<string, string> = {
  SELF: "Self",
  SPOUSE: "Spouse",
  PARENT: "Parent",
  OTHER: "Other",
};

const PatientInsuranceDetails = ({ values }: PatientInsuranceDetailsProps) => {
  // Format date
  const formatDate = (date: any) => {
    if (!date) return "";
    try {
      return dayjs(date).format(DATE_FORMAT);
    } catch {
      return "";
    }
  };

  // Format insurance data
  const formatInsuranceData = (insurance: any): { [key: string]: string } => {
    if (!insurance) return {};
    return {
      "Card Holder": insurance.relationshipToPatient
        ? PRIMARY_CARD_HOLDER_MAPPER[insurance.relationshipToPatient] ||
          insurance.relationshipToPatient
        : "",
      "Policy Holder Name": insurance.subscriberName || "",
      "Insurance Company": insurance.insuranceProvider || "",
      "ID Number": insurance.policyNumber || "",
      "Group Number": insurance.groupNumber || "",
      "Subscriber DOB": formatDate(insurance.subscriberDOB),
      "Subscriber SSN": insurance.subscriberSSN || "",
    };
  };

  // Build general insurance info
  const generalInfo: { [key: string]: string } = {
    "Do You Have Insurance": values.primaryInsurance ? "Yes" : "No",
  };

  if (values.primaryInsurance) {
    generalInfo["Do You Have Secondary Insurance"] = values.secondaryInsurance
      ? "Yes"
      : "No";
  }

  // Prepare primary insurance data
  const primaryInsuranceData =
    values.primaryInsurance && values.primary
      ? formatInsuranceData(values.primary)
      : null;

  // Prepare secondary insurance data
  const secondaryInsuranceData =
    values.secondaryInsurance && values.secondary
      ? formatInsuranceData(values.secondary)
      : null;

  // Check if there's any insurance data
  // const hasInsuranceData = primaryInsuranceData || secondaryInsuranceData;

  return (
    <Box mt={0.5} id={"Patient insurance"}>
      <Text mb={2}>INSURANCE INFORMATION</Text>

      {/* General Insurance Information */}
      {/* <Box mb={2}>
        <ProfileViewer
          data={generalInfo}
          withoutColn
          firstColW={5}
          secondColW={7}
        />
      </Box> */}

      {/* Show "No Insurance" if no insurance data */}
      {/* {!hasInsuranceData && (
        <Box mb={2}>
          <Text>No Insurance</Text>
        </Box>
      )} */}

      {/* Primary Insurance Card */}
      {primaryInsuranceData && (
        <Box mb={2}>
          <OutlineCard>
            <Box p={2}>
              <Text variant="h6" fontWeight="medium" mb={1}>
                Primary Insurance
              </Text>
              <ProfileViewer
                data={primaryInsuranceData}
                withoutColn
                firstColW={3}
                secondColW={9}
              />
            </Box>
          </OutlineCard>
        </Box>
      )}

      {/* Secondary Insurance Card */}
      {secondaryInsuranceData && (
        <Box mb={2}>
          <OutlineCard>
            <Box p={2}>
              <Text variant="h6" fontWeight="medium" mb={1}>
                Secondary Insurance
              </Text>
              <ProfileViewer
                data={secondaryInsuranceData}
                withoutColn
                firstColW={3}
                secondColW={9}
              />
            </Box>
          </OutlineCard>
        </Box>
      )}
    </Box>
  );
};

export default PatientInsuranceDetails;
